<div> 
    <p>You're trying to change the product <b>{{data.name}}</b>, Do you want to update?</p>
</div>

<div style="display: flex;justify-content: center;">
    <button class="save btn" (click)="save(1)" style="width: fit-content;">No</button>
    <button class="save btn" (click)="save(2)" style="width: fit-content;">Yes</button>
</div>